import { INITIALIZE_FORM_COVERAGE_CONFIG } from '../actionTypes';
import { configurationCoveragesActions } from '../reducer';

export default (values) =>
    configurationCoveragesActions[INITIALIZE_FORM_COVERAGE_CONFIG](values);
